<div class="app-select" ngbDropdown #myDrop="ngbDropdown">
  <button
    class="app-select__toggle-button"
    [ngClass]="{ 'app-select__text--placeholder': !initBy }"
    ngbDropdownToggle
    name="{{ name }}"
    id="{{ name }}"
    [disabled]="isDisabled || disabled"
    type="button"
  >
    {{ getSelected() }}
  </button>
  <div ngbDropdownMenu class="dropdown-menu">
    <button ngbDropdownItem [disabled]="isDisabled || disabled" *ngIf="nullChoice" class="app-select__text--placeholder" type="button" (click)="onReset(); $event.stopPropagation(); myDrop.close()">
      <i>{{ defaultText }}</i>
    </button>
    <button ngbDropdownItem [disabled]="isDisabled || disabled" *ngFor="let item of items" type="button" (click)="onSelect(item); $event.stopPropagation(); myDrop.close()">
      {{ item[textKey] || item }}
    </button>
  </div>
</div>
